import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { updateSocket } from '../../utils/socket';

const SocketUpdater = () => {
    const context = useSelector(state => state.socket.context);

    useEffect(() => {
        updateSocket('context-update', context);
    }, [context]);

    return null;
};

export default SocketUpdater;
